import { LuCircleHelp } from "react-icons/lu";
import { useUserSubscription } from "../../../core_stores/useSubscriptionStore";
import { formatTokensNumber } from "../../../utils/numberFormatter";

export default function SubscriptionsRemainingTokens() {
  return (
    <div
      className="bg-[#D7DAE9] dark:bg-[#2A2E34] 
        text-light-placeholder dark:text-dark-placeholder
      rounded-lg px-4 py-3 relative
      flex items-center justify-between gap-2"
    >
      <InfoAboutRemainingTokens />
      <span
        className="cursor-pointer"
        data-tooltip-id="remaining-tokens-tooltip"
      >
        <LuCircleHelp size={20} />
      </span>
    </div>
  );
}

function InfoAboutRemainingTokens() {
  const subscription = useUserSubscription();

  return (
    <div className="text-sm flex flex-wrap items-center">
      Tokens remaining in current period:
      <span className="whitespace-nowrap">
        <span className="font-semibold text-light-text dark:text-dark-text">
          &nbsp;{formatTokensNumber(subscription?.remaining ?? 0)}
        </span>
        ,
      </span>
      &nbsp;active until:
      <span className="font-semibold text-light-text dark:text-dark-text">
        &nbsp;{subscription?.period.end}
      </span>
      .
    </div>
  );
}
